(function () {
    'use strict';

    angular
        .module('app')
        .directive('videoModal', videoModal);

    videoModal.$inject = ['$window'];

    function videoModal($window) {
        var directive = {
            bindToController: true,
            controller: ['$scope', '$location', controller],
            controllerAs: '$videoModal',
            restrict: 'EA',
            link: link
        };

        return directive;

        function link($scope) {
            
        }

        function controller($scope) {
            var $ctrl = this;

            $ctrl.pause = function() {
                var div = document.getElementById("videoModal");
                var iframe = div.getElementsByTagName("iframe")[0].contentWindow;

                iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }
        }
    }

})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_videoModal.js
// module id = 21
// module chunks = 0